export default __webpack_public_path__ + "static/media/miut_gutter.c53d4849.jpg";